import Rule from './Rule.vue'

export default Rule
